// @ts-nocheck
import { Toast } from "antd-mobile";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getText } from "../../../../utils/util";

export default function TopPage({ coinList, addAddress, delAddress }) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const [sendData, setSendData] = useState({
    name: "",
    czline: "",
    oid: 0,
    address: "",
    remark: "",
  });
  //coin类
  const getCoinNodes = () => {
    const nodes = [];
    for (const coin of coinList) {
      if (coin.name) {
        const node = (
          <div
            key={coin.id}
            className={`flex items-center mr-4 mt-2 cursor-pointer ${
              sendData.name === coin.name + coin.czline
                ? "text-primary"
                : "text-neutral-400"
            }`}
            onClick={() => {
              setSendData({
                ...sendData,
                czline: coin.czline,
                name: coin.name + coin.czline,
                oid: coin.id,
              });
            }}
          >
            <div className="flex-shrink-0">
              <div
                className={`w-5 h-5 rounded-full flex items-center justify-center border ${
                  sendData.name === coin.name + coin.czline
                    ? "bg-primary border-primary"
                    : "border-neutral-600"
                }`}
              >
                {sendData.name === coin.name + coin.czline && (
                  <div className="w-2 h-2 bg-white rounded-full"></div>
                )}
              </div>
            </div>
            <span className="ml-2 text-sm">{`${coin?.name.toUpperCase()}${
              coin.czline ? `-${coin.czline}`.toUpperCase() : ""
            }`}</span>
          </div>
        );
        nodes.push(node);
      }
    }
    return nodes;
  };

  //修改对象值
  const updateSendData = (e) => {
    const name = e.target.name;
    setSendData({
      ...sendData,
      [name]: e.target.value,
    });
  };
  //点击回调提前处理
  const callBack = () => {
    if (!(sendData.name && sendData.address)) {
      Toast.show({ content: translate(getText("請填寫完整信息")) });
      return;
    }
    addAddress(sendData);
  };

  return (
    <div className="text-white">
      <div className="bg-neutral-800 rounded-lg mt-4 md:max-w-2xl md:mx-auto">
        <div className="border-b border-neutral-700 p-4 text-left text-lg font-medium">
          {translate(getText("添加地址"))}
        </div>
        <div className="p-4">
          <div className="mb-6">
            <div className="text-left mb-2 text-neutral-300">
              {translate(getText("選擇協議"))}
            </div>
            <div role="radiogroup" className="flex flex-wrap">
              {getCoinNodes()}
            </div>
          </div>
          <div className="mb-6">
            <div className="text-left mb-2 text-neutral-300">
              {translate(getText("錢包地址"))}
            </div>
            <div className="relative">
              <input
                type="text"
                name="address"
                value={sendData.address}
                placeholder={translate(getText("提幣地址"))}
                onChange={updateSendData}
                className="w-full p-3 bg-neutral-900 border border-neutral-700 rounded-lg text-white placeholder-neutral-500 focus:outline-none focus:ring-1 focus:ring-primary"
              />
            </div>
          </div>
        </div>
        <div className="p-4 pt-0">
          <button
            onClick={callBack}
            className="w-full py-3 bg-gradient-primary rounded-lg text-white font-medium transition hover:opacity-90"
          >
            {translate(getText("提交"))}
          </button>
        </div>
      </div>
    </div>
  );
}
